export default "__VITE_ASSET__CljwKOoC__"